import React, { useState, useEffect } from "react";
import "./DownloadFile.css";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import BackBtn from "../../Components/BackBtn/BackBtn";
import BottomBar from "../../Components/BottomBar/BottomBar";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Alert from "../../Components/Alert/Alert";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function DownloadFile() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [filesList, setFilesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  useEffect(() => {
    const fetchFilesList = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/diet_plan/pdf`,
          {
            headers: { Authorization: `Token ${userToken}` },
          }
        );
        setIsLoading(false);
        setFilesList(response.data.pdf_files);
        if (response.data.pdf_files.length === 0) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("موردی یافت نشد");
          return;
        }
      } catch (error) {
        console.error("Error fetching files:", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (userToken) {
      fetchFilesList();
    }
  }, [baseUrl, userToken]);

  const handleDownloadFile = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("در حال دانلود فایل...");
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="pageTitle horizontalBorder">دانلود فایل</div>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="filesList centeredFlex scroll">
              {filesList.map((file, index) => (
                <a
                  key={index}
                  href={file.diet_pdf ? file.diet_pdf : "#"}
                  download={file.name || "downloaded_file.pdf"}
                  className="pdfFileLink link"
                  rel="noopener noreferrer"
                  onClick={handleDownloadFile}
                >
                  <div className="pdfFile centeredFlex">
                    {file.name}
                    <img
                      src="/images/ic_cloud.svg"
                      alt="cloud"
                      className="cloudDownload"
                    />
                  </div>
                </a>
              ))}
            </div>
          )}
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
